import React from "react";
import "./Live_button.css";

function Live_button() {
  return (
    <div>
      <div>
        <table align="center">
          <tr>
            <td>
              <div id="bloc1">
                {" "}
                <button className="live">Live</button>
              </div>
            </td>
            <td>
              <div id="bloc2">
                <div className="livetv">TV </div>
              </div>
            </td>
            <td>
              <div className="livename">
                <sub>Derana</sub>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
}

export default Live_button;
